import { getCoprincipalAccountForMailboxInfo } from "owa-account-source-list-store";
import { isEnterprise } from "owa-account-source-list-internal";
import type { MailboxInfo } from "owa-client-types";

export function getAnchorMailboxForSharedOrDelegateUserMailbox(mailboxInfo: MailboxInfo): string {
    const accountSource = getCoprincipalAccountForMailboxInfo(mailboxInfo);
    if (accountSource) {
        if (isEnterprise(accountSource)) {
            return mailboxInfo.mailboxSmtpAddress;
        }
        
        return `MSA:${mailboxInfo.mailboxSmtpAddress}`;
    }
    
    return mailboxInfo.mailboxSmtpAddress;
}
